<div class="modal-header">
    <h3 class="modal-title">{{ 'MANIP_CONTROLS_AT_BOTTOM.TITLE' | translate }}</h3>
</div>
<div class="modal-body">
    {{ 'MANIP_CONTROLS_AT_BOTTOM.BODY' | translate }}
    <div class="center animated bounce infinite aqua">
        <fa-icon [icon]="['fas','arrow-down']"></fa-icon>
    </div>
</div>